import { URLS } from '@/configs/urls'

function normalizePathname(pathname: string): string {
  const withoutQuery = pathname.split('?')[0] ?? pathname
  if (withoutQuery.length > 1 && withoutQuery.endsWith('/')) {
    return withoutQuery.slice(0, -1)
  }
  return withoutQuery
}

/** Routes that require an authenticated session (fan/club private areas). */
export function isProtectedAppPath(
  pathname: string | null | undefined
): boolean {
  if (!pathname) {
    return false
  }

  const path = normalizePathname(pathname)

  // Fan cabinet only. Public club profiles (`/clubs/{id}`) stay open to guests
  // (OCE-2493); club-owner routing is enforced server-side in runClubGuard.
  return path === URLS.PROFILE || path.startsWith(`${URLS.PROFILE}/`)
}
